export default {
    path : "factory-item-recycled",
    name : "factory-item-recycled",
    meta : {
        title : "关注项目"
    },
    component: () => import('@/pages/factory/recycled/Index'),
    redirect: {
        name : "factory-item-recycled-whole"
    },
    children: [
        {
            path: 'all',
            name: 'factory-item-recycled-whole',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'factory-item-recycled-recent',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'factory-item-recycled-atme',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'factory-item-recycled-meat',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'factory-item-recycled-reply',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'factory-item-recycled-search',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/factory/recycleditem/index.js